import React from 'react';

import { Nice } from '@/core/components/ProfileDetails/bagdes/Nice';
import { Punctual } from '@/core/components/ProfileDetails/bagdes/Punctual';
import { ProfileTitle } from '@/core/components/ProfileDetails/components';
import type UserDomain from '@/core/lib/new-architecture/domain/user.domain';
import { useTranslationContext } from '@/core/lib/translation/translation.context';
import { IconSuperUserActive } from '@/core/pages/profile/PublicProfile/Status/IconSuperUserActive';
import { IconSuperUserInactive } from '@/core/pages/profile/PublicProfile/Status/IconSuperUserInactive';

export const UserStatusSection: React.FC<Pick<UserDomain['status'], 'isNice' | 'isPunctual' | 'isSuperUser'> & { showInactive?: boolean; isSmall?: boolean; className?: string }> = ({
  isNice,
  isPunctual,
  isSmall,
  showInactive,
  isSuperUser,
  className,
}) => {
  const { t } = useTranslationContext(['common']);

  const showPonctualStatus = showInactive || isPunctual;
  const showNiceStatus = showInactive || isNice;
  const showSuperUser = showInactive || isSuperUser;

  const sectionIsEmpty = ![showSuperUser, showNiceStatus, showPonctualStatus].some(Boolean);

  if (sectionIsEmpty) return null;
  const iconClassName = isSmall ? 'size-13' : 'size-18 max-lg:size-13';

  return (
    <section className={`space-y-2 lg:space-y-3 ${className}`}>
      <ProfileTitle tag="h2" isSmall={isSmall}>
        {t('components.profile.public.status-title', { ns: 'common' })}
      </ProfileTitle>
      <div className="text-body-secondary text-caption-primary flex gap-3 text-center max-lg:gap-5">
        {showNiceStatus && (
          <div className="flex flex-col items-center gap-2">
            <Nice className={iconClassName} isActive={isNice} />
            <p>{t('components.badges.is-nice', { ns: 'common' })}</p>
          </div>
        )}
        {showPonctualStatus && (
          <div className="flex flex-col items-center gap-2">
            <Punctual className={iconClassName} isActive={isPunctual} />
            <p>{t('components.badges.is-punctual', { ns: 'common' })}</p>
          </div>
        )}
        {showSuperUser && (
          <div className="flex max-w-[66px] flex-col items-center gap-2">
            {isSuperUser ? <IconSuperUserActive className={iconClassName} /> : <IconSuperUserInactive className={iconClassName} />}
            <p>{t('components.badges.is-super-user', { ns: 'common' })}</p>
          </div>
        )}
      </div>
    </section>
  );
};
